module.exports = __webpack_public_path__ + "img/1.77c19a08.png";